export default __webpack_public_path__ + "static/media/down-icon-active.0b485fdf.svg";